import React from "react";

export default function MagneticButton({ children, href, onClick, variant = "primary", className = "", testId, type }) {
  const ref = React.useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - (r.left + r.width / 2);
    const y = e.clientY - (r.top + r.height / 2);
    el.style.transform = `translate(${x * 0.2}px, ${y * 0.2}px)`;
  };
  const onLeave = () => {
    if (ref.current) ref.current.style.transform = "translate(0,0)";
  };

  const base = "inline-flex items-center justify-center px-8 py-4 text-xs tracking-[0.24em] uppercase transition-colors duration-400 will-change-transform";
  const styles =
    variant === "primary"
      ? "bg-[#B5896E] text-[#FAF6F0] hover:bg-[#D4A88E]"
      : "border border-[#B5896E]/60 text-[#4A3F35] hover:bg-[#B5896E]/10 hover:border-[#B5896E]";

  const inner = (
    <span
      ref={ref}
      className={`${base} ${styles} ${className}`}
      style={{ transition: "transform 500ms cubic-bezier(0.22,1,0.36,1), background-color 400ms, border-color 400ms, color 400ms" }}
    >
      {children}
    </span>
  );

  if (href) {
    return (
      <a data-testid={testId} href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" onMouseMove={onMove} onMouseLeave={onLeave} className="inline-block">
        {inner}
      </a>
    );
  }
  return (
    <button data-testid={testId} type={type || "button"} onClick={onClick} onMouseMove={onMove} onMouseLeave={onLeave} className="inline-block">
      {inner}
    </button>
  );
}
